export class LhlpIdentity {

    public static fetch(): Promise<LhlpUser> {
        return new Promise<LhlpUser>(
            function (resolve, reject) {

                let target: string = "api/identity/get";

                // jk - finding endpoint by above relative URL was failing for tenants under some circumstances
                let ele = $("#theMap");
                if (ele.length === 1) {
                    let siteFolder: string = <string>ele.data("site-folder");
                    if (siteFolder.length > 0) {
                        target = `/${siteFolder}/${target}`;
                    }
                }

                $.getJSON(target, function (response) {
                    resolve(response);
                }).fail(function () {
                    resolve(null);
                });
            }
        );
    }
}

export class LhlpUser {
    public userId: string;
    public roles: Array<string>;
}